/* Henric's navigation on Dawn; delegated events also work in the theme editor. */
(() => {
  const closeMenu = (focus = false) => {
    const menu = document.getElementById('page-menu');
    const button = document.querySelector('[data-hf-menu-toggle]');
    if (!menu || !button) return;
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Abrir menú');
    if (focus) button.focus();
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-hf-menu-toggle]');
    if (toggle) {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      menu.hidden = !expanded;
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Cerrar menú' : 'Abrir menú');
      return;
    }
    const link = event.target.closest('a');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (link.closest('#page-menu')) closeMenu();
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    history.replaceState(null, '', url.hash);
    target.scrollIntoView({ behavior: 'auto', block: 'start' });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.querySelector('[data-hf-menu-toggle][aria-expanded="true"]')) closeMenu(true);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-hf-localization]')) event.target.form.requestSubmit();
  });
  document.addEventListener('shopify:section:unload', () => closeMenu());
  matchMedia('(min-width: 1100px)').addEventListener('change', (event) => {
    if (event.matches) closeMenu();
  });
})();
